import React, { createContext } from "react";

import "./Boards.css";
import console from "../../images/Boards/console.png";

function Boards() {
  return (
    <div className="boards">
        <div className="boards__items">
          <div className="boards__title"> ПРОМЫШЛЕННЫЕ НАСОСЫ И АГРЕГАТЫ </div>
          <div className="board__hidden1"></div>
          <div className="boardd1">
            <div className="board-text">Консольные насосы</div>
          </div>
          <div className="boardd2">
            <div className="board-text">Двухопорные насосы типа Д</div>
          </div>
          <div className="boardd3">
            <div className="board-text">Многосекционные насосы</div>
          </div>
          <div className="board__hidden4"></div>
          <div className="boardd4">
            <div className="board-text">Погружные насосы</div>
          </div>
          <div className="board__hidden2"></div>
          <div className="boardd5">
            <div className="board-text">Полупогружные насосы</div>
          </div>
          <div className="boardd6">
            <div className="board-text">Насосы типа In-Line</div>
          </div>
          <div className="boardd7">
            <div className="board-text">Герметичные насосы</div>
          </div>
          <div className="board__hidden3"></div>
        </div>
    </div>
  );
}

export default Boards;
